import { render, staticRenderFns } from "./MallShoppingCartIcon.vue?vue&type=template&id=15391baa&scoped=true&"
import script from "./MallShoppingCartIcon.vue?vue&type=script&lang=ts&"
export * from "./MallShoppingCartIcon.vue?vue&type=script&lang=ts&"
import style0 from "./MallShoppingCartIcon.vue?vue&type=style&index=0&id=15391baa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15391baa",
  null
  
)

export default component.exports